import api from '../api/ad';
var $$model = require('assets/util/model.js');

var _ = window._;

var model = new $$model({});

var assert = require('assets/util/assert.js');

_.extend(model, {
    loupan: (params) => {
        assert(params, {
            pid: 'n',
            projName: 's',
            cityId: 'n,r',
            cityName: 's,r',
            sign: 's'
        });

        var data = {
            type: 0,
            domain: window.location.hostname,
            refererUrl: window.document.referrer,
            sourceAgent: 1
        };
        _.extend(data, params);

        return api.sendLogForAd(data);
    }
});
module.exports = model;



// WEBPACK FOOTER //
// ./src/model/service/log.js